export default "__VITE_ASSET__DhpjP0Gd__"